import React, {Component} from "react";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {Col, Container, Row} from "reactstrap";
import {toast} from "react-toastify";

import TeamMemberCard from "../../components/team-member-card/team-member-card";
import Button from "../../components/button/button";

import {getRoles} from "../../../modules/system/role";
import {resetUserState, getTeamMembers, setPersonnelLockoutStatus} from "../../../modules/user";
import {setPageTitle} from "../../../modules/application/pages";
import {parseQuery} from "../../../transformations/queryString";

import "./team-members.css";

class TeamMembers extends Component {
    componentWillMount() {
        this.setState({
            teamMembers: []
        });

        this.props.dispatch(setPageTitle("Team Members"));
        //this.props.dispatch(getUsers([], "first_name,last_name"));
        this.props.dispatch(getRoles())
    }

    async setTeamMemberLockoutStatus(teamMemberID, newStatus) {
        let {token} = this.props;
        let lockoutUpdateResponse = await setPersonnelLockoutStatus(token, teamMemberID, newStatus);

        if (lockoutUpdateResponse.data.success) {
            this.updateTeamMemberAfterLockoutUpdate(teamMemberID, newStatus);
        }        
    }

    updateTeamMemberAfterLockoutUpdate(teamMemberID, newStatus) {
        let {teamMembers} = this.state;

        let newTeamMembers = [...teamMembers];

        for (let index in newTeamMembers) {
            let currentTeamMember = newTeamMembers[index];
            if (currentTeamMember.id === teamMemberID) {
                currentTeamMember.lockout = newStatus;
                newTeamMembers[index] = currentTeamMember;
            }
        }

        this.setState({teamMembers: newTeamMembers});
    }

    async componentDidMount() {
        const {token} = this.props;
        let teamMembersResponse = await getTeamMembers(token, true);

        if (teamMembersResponse.data && teamMembersResponse.data.success) {
            let teamMembers = teamMembersResponse.data.team_members;
            this.setState({teamMembers: teamMembers});
        }

        const queryString = parseQuery(window.location);

        if (queryString && queryString.message) {
            const message = queryString.message;

            toast.success(unescape(message), {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }


    displayTeamMembers(lockout) {
        const {teamMembers} = this.state;
        let {user} = this.props;

        let userID = -1;
        if (user) {
            userID = user.currentUserId;        
        }

        let self = this;
        return teamMembers.map(function (user) {
            const userRole = user.roles[0];
            let isLoggedInUser = false;
            if (user.id === userID) {
                isLoggedInUser = true;
            }

            if (lockout && user.lockout) {
                return (
                    <Col md="6" key={user.id}>
                        <TeamMemberCard lockout_func={self.setTeamMemberLockoutStatus.bind(self)} teamMember={user}
                                        role={userRole}
                                        me={isLoggedInUser}
                                        isAdminRole={self.props.isAdminRole}/>
                    </Col>
                );
            }
            else if (!lockout && !user.lockout) {
                return (
                    <Col md="6" key={user.id}>
                        <TeamMemberCard lockout_func={self.setTeamMemberLockoutStatus.bind(self)} teamMember={user}
                                        role={userRole}
                                        me={isLoggedInUser}
                                        isAdminRole={self.props.isAdminRole}/>
                    </Col>
                );
            }
            else {
                return "";
            }
        }); 
    }

    render() {
        const {isAdminRole} = this.props;
        const {teamMembers} = this.state;
        return (
            <Container className="Team-Members-container">
                {isAdminRole &&
                <div className="m-3 text-left">
                    <Link to="/teamMember">
                        <Button text="Add Team Member" color="primary" onClick={() => {
                            this.props.dispatch(resetUserState());
                        }}/>
                    </Link>
                </div>
                }
                <Row>
                    {teamMembers && this.displayTeamMembers(false)}
                    {teamMembers && this.displayTeamMembers(true)}
                </Row>
            </Container>
        );
    }
}

const withState = connect(state => {
    const {role, user} = state;

    // This is absolutely not the way to do this... I could not figure out the appropriate url query
    //   It could be done in a flask endpoint, but I feel this should be possible in eve
    // https://stackoverflow.com/questions/50298923/how-do-i-query-resources-in-the-nested-collection-in-eve-sqlalchemy
    // let users = user.users;
    //let organization = user.organization;

    // if (users && !user.isSuperRole) {
    //     users = users.filter(user => {
    //         return user.organizations && user.organizations.includes(organization)
    //     })
    // }

    return {
        roles: role.roles,
        // users: users,
        user: user,
        token: user.token,
        isSuperRole: user.isSuperRole,
        isAdminRole: user.isAdminRole
    };
});

export default withRouter(withState(TeamMembers));



// WEBPACK FOOTER //
// ./src/components/containers/team-members/team-members.js